// 动态创建路由
export let createRoutes = function (children, data) {
  // 把 Summary 去掉注释，即可不登录也能进入到页面
  // children.push({
  //   path: '/Summary',
  //   name: 'Summary',
  //   component: () => import('@/views/Summary/Summary.vue'),
  // })
  // children.push({ path: '/HomePagePDF', name: '/HomePagePDF', component: () => import('@/components/Form/BaseForm') })
  children.push({
    path: '/HomeRedirect',
    name: '/HomeRedirect',
    component: () => import('../views/home/HomeRedirect.vue'),
  })
  data.forEach((item) => {
    generateRoutes(children, item)
  })
  sessionStorage.setItem('routerchildren', JSON.stringify(children))
}

function generateRoutes(children, item) {
  if (
    item.path != null &&
    item.path !== '' &&
    (!item.children || item.children.length === 0)
  ) {
    let path = item.md5Path
    let option = children.filter((item) => {
      return item.name === '/' + path
    })
    if (option.length === 0) {
      children.push({
        path: '/' + path,
        name: '/' + path,
        component: () => import('@/views/' + item.directory + '/' + item.path + '.vue'),
      })
    }
  } else if (item.children) {
    item.children.forEach((e) => {
      generateRoutes(children, e)
    })
  }
}